import React from 'react'

import { SectionWrapper, SectionTitle } from '../../components/Section'
import FormInfo from '../../components/FormFields/FormInfo'
import Separator from '../../components/Separator'

import ProfileDataForm from './ProfileDataForm'
import ProfilePasswordForm from './ProfilePasswordForm'
import ProfileDeleteButton from './ProfileDeleteButton'

function Profile({ userProfile }) {
  return (
    <SectionWrapper>
      <SectionTitle>Mi perfil</SectionTitle>
      <FormInfo>En está página puedes actualizar tus datos de perfil, cambiar tu contraseña y/o pedir la eliminación completa de tu perfil con lo que eliminaremos todos los datos y documentos que tengamos guardados sobre tu usuario y solicitudes.</FormInfo>
      <ProfileDataForm userProfile={userProfile} />
      <Separator />
      <ProfilePasswordForm userProfile={userProfile} />
      <Separator />
      <ProfileDeleteButton userProfile={userProfile} />
    </SectionWrapper>
  )
}

export default Profile
